/*
  customer-sync.js — mirrors every storefront contact submission into the
  Customers database via our Convex endpoint, WITHOUT touching the native
  submit. Shopify still sends the owner email (and shows /challenge); this
  just fires a parallel, keepalive POST to Convex that creates the customer
  server-side (Admin API, no captcha).

  Enabled only when window.KM_CONVEX_URL is set (snippets/customer-sync.liquid,
  driven by the `convex_submit_url` theme setting). No-op otherwise.

  Body is text/plain → "simple" request → no CORS preflight. Response is never
  read (fire-and-forget), so the entry lands even as the page navigates.
*/
(function () {
  var ENDPOINT = window.KM_CONVEX_URL;
  if (!ENDPOINT) return;

  function field(form, name) {
    var el = form.querySelector('[name="contact[' + name + ']"]');
    return el ? (el.value || '') : '';
  }

  function isContactForm(form) {
    var ft = form.querySelector('input[name="form_type"]');
    return !!ft && ft.value === 'contact';
  }

  function buildPayload(form) {
    var email = field(form, 'email').trim();
    if (!email) return null;

    var name = field(form, 'name').trim();
    if (!name) {
      name = (field(form, 'first_name') + ' ' + field(form, 'last_name')).trim();
    }

    // Type: the drawer sets a hidden contact[Type]; site forms use data-customer-tag.
    var typeField = form.querySelector('[data-enquiry-type-field]');
    var type = typeField && typeField.value ? typeField.value : 'Enquiry';
    if (!typeField && form.dataset.customerTag === 'commercial-enquiry') type = 'Commercial enquiry';

    var honeypot = form.querySelector('[name="km_hp"]');
    var ctx = window.__STORE_CONTEXT__ || {};

    return {
      name: name,
      email: email,
      type: type,
      productTitle: field(form, 'Enquiry about'),
      productUrl: field(form, 'Product URL'),
      customerId: ctx.customerId ? String(ctx.customerId) : null,
      website: honeypot ? honeypot.value : '',
    };
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !isContactForm(form)) return;
      if (form.dataset.noCustomerSync != null) return;

      var data = buildPayload(form);
      if (!data) return;

      try {
        fetch(ENDPOINT, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'text/plain' },
          keepalive: true,
          mode: 'cors',
        });
      } catch (_) {
        /* best-effort — never block the native Shopify submit */
      }
      // No preventDefault: Shopify's native submit (email + captcha) proceeds.
    },
    true
  );
})();
